/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { checkErrorResponse, Logger, LoggerTypes } from '../../../../../utils'
import { DialogFormEdit } from '../../../../dialogs'
import { AttributeProductForm } from '../../AttributeProductForm'

export const AttributeProductDialogUpdate = ({
  currentProject,
  currentScenario,
  actionUpdateDispatch,
  openDialog,
  setOpenDialog,
  product
}) => {
  const [errors, setErrors] = useState(null)

  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const title = currentScenario
    ? t('attributes.products.update.scenario')
    : currentProject
    ? t('attributes.products.update.project')
    : t('attributes.products.update.global')

  /**
   * Action received from the Product Form.
   * @see AttributeProductForm
   *
   * @param {object} newProduct Product attribute object to update.
   * @param {string} newProductId Product attribute Id to update.
   * @param {func} onSuccess Function to execute on success.
   */
  const onDispatchAction = (newProduct, newProductId, onSuccess) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeProductDialogUpdate.onDispatchAction()', {
      newProduct,
      newProductId,
      actionUpdateDispatch
    })

    if (actionUpdateDispatch) {
      dispatch(actionUpdateDispatch(newProduct, newProductId, currentProject?.id, currentScenario?.id))
        .then((res) => {
          Logger.trace(
            LoggerTypes.CONTROLLER,
            'AttributeProductDialogUpdate.onDispatchAction().dispatch(actionUpdateDispatch(...)).then()',
            {
              res
            }
          )
          if (res?.data?.isAxiosError) {
            enqueueSnackbar(t('common.api_failure'), { variant: 'error' })
          } else if (onSuccess && typeof onSuccess === 'function') {
            onSuccess(res)
          }
        })
        .catch((res) => {
          Logger.trace(
            LoggerTypes.WARN,
            'AttributeProductDialogUpdate.onDispatchAction().dispatch(actionUpdateDispatch(...)).catch()',
            { res }
          )

          checkErrorResponse(res, enqueueSnackbar, t)

          const _data = res?.response?.data || null
          if (_data && (_data?.fields || _data?.error)) {
            let _error = _data?.fields || {}
            if (_data?.error) {
              _error.generic = _data.error
            }
            setErrors(_error)
          }
        })
    } else {
      Logger.trace(LoggerTypes.WARN, 'AttributeProductDialogUpdate.onDispatchAction().catch()', {
        currentProject,
        currentScenario,
        actionUpdateDispatch
      })
    }
  }

  Logger.trace(LoggerTypes.CONTAINER, 'AttributeProductDialogUpdate.render()', {
    currentProject,
    currentScenario,
    product
  })

  return (
    <DialogFormEdit className="attribute-form" openDialog={openDialog} setOpenDialog={setOpenDialog}>
      <AttributeProductForm
        title={title}
        setOpenDialog={setOpenDialog}
        product={product}
        dispatchAction={onDispatchAction}
        errors={errors}
      />
    </DialogFormEdit>
  )
}

AttributeProductDialogUpdate.displayName = 'AttributeProductDialogUpdate'

AttributeProductDialogUpdate.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  actionUpdateDispatch: PropTypes.func.isRequired,
  product: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    quantity: PropTypes.number,
    weight: PropTypes.number,
    dimensions: PropTypes.string
  }).isRequired
}

AttributeProductDialogUpdate.defaultProps = {
  currentProject: null,
  currentScenario: null,
  openDialog: false,
  setOpenDialog: () => {},
  actionUpdateDispatch: null,
  product: {
    name: null,
    description: null,
    quantity: null,
    weight: null,
    dimensions: null
  }
}
